import { render, staticRenderFns } from "./elCheckBoxTree.vue?vue&type=template&id=1f0c8920&"
import script from "./elCheckBoxTree.vue?vue&type=script&lang=js&"
export * from "./elCheckBoxTree.vue?vue&type=script&lang=js&"
import style0 from "./elCheckBoxTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports